import libs from "./lib/dependencies.js";
window.libs = libs;
$ = jQuery;

// import scripts
import initScrollTo from "./scripts/scroll-to.js";
import initMenu from "./scripts/menu.js";
import initIntroAnimation from "./scripts/intro-animation.js";
import initReveal from "./scripts/reveal.js";
import scrollDirection from "./scripts/scroll-direction.js";
import calcVh from "./scripts/calc-vh.js";

// import partials

// import sections
import initSlider from "./sections/slider.js";

// import modules
import initReadMore from "./modules/read-more.js";
import initAccordion from "./modules/accordion.js";
import initContentSlider from "./modules/content-slider.js";
import initVideoLightbox from "./modules/video-lightbox.js";

// jquery testing
// $(document).ready(() => {
//   console.log("jQuery is working");
// });

// remove no-js class
document.body.classList.remove("no-js");

// run page init function
function init() {
  // init scripts
  initMenu();
  initScrollTo();
  initIntroAnimation();
  initReveal();
  scrollDirection();
  calcVh();

  // init partials

  // init sections
  initSlider();

  // init modules
  initReadMore();
  initAccordion();
  initContentSlider();
  initVideoLightbox();

  // remove preload class
  document.body.classList.remove("preload");
}

init();
